<template lang="pug">
    v-card
        v-card-title.d-flex.align-center.flex-column.justify-center
            h3.mt-4.mb-0 {{$t('AGENT.ICON')}}
        v-sheet.mb-6(max-height="600")
            v-row.ma-1(justify="center" align="center")
                v-col(cols="auto" v-for="icon_obj in iconList" :key="icon_obj.name" class="d-flex justify-center")
                    v-btn(depressed icon fab small @click="saveIcon(icon_obj)")
                        v-img(:src="icon_obj.path" width="44")
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    props: {
        currentIconPath: {
            type: String,
            required: true,
        },
    },
    data(){
        return { 
            selectedIcon: "default",
            iconList: [
                { name: "idea", path: require("@/assets/images/agent_icon/idea.png") },
                { name: "cloud", path: require("@/assets/images/agent_icon/cloud.png") },
                { name: "award", path: require("@/assets/images/agent_icon/award.png") },
                { name: "speclist", path: require("@/assets/images/agent_icon/speclist.png") },
                { name: "generate", path: require("@/assets/images/agent_icon/generate.png") },
                { name: "default", path: require("@/assets/images/agent_icon/default.png") },
                { name: "knowledge", path: require("@/assets/images/agent_icon/knowledge.png") },
                { name: "message", path: require("@/assets/images/agent_icon/message.png") },
                { name: "customerservice", path: require("@/assets/images/agent_icon/customerservice.png") },
                { name: "report", path: require("@/assets/images/agent_icon/report.png") },
                { name: "shopping_cart", path: require("@/assets/images/agent_icon/shopping_cart.png") },
                { name: "construction", path: require("@/assets/images/agent_icon/construction.png") },
                { name: "translate", path: require("@/assets/images/agent_icon/translate.png") },
                { name: "metal", path: require("@/assets/images/agent_icon/metal.png") },
                { name: "questionandanswer", path: require("@/assets/images/agent_icon/questionandanswer.png") },
                { name: "humanresource", path: require("@/assets/images/agent_icon/humanresource.png") },
                { name: "robot", path: require("@/assets/images/agent_icon/robot.png") },
                { name: "finance", path: require("@/assets/images/agent_icon/finance.png") },
                { name: "setting", path: require("@/assets/images/agent_icon/setting.png") },
                { name: "policy", path: require("@/assets/images/agent_icon/policy.png") },
                { name: "searchimage", path: require("@/assets/images/agent_icon/searchimage.png") },
                { name: "target", path: require("@/assets/images/agent_icon/target.png") },
                { name: "conversation", path: require("@/assets/images/agent_icon/conversation.png") },
                { name: "record", path: require("@/assets/images/agent_icon/record.png") },
                { name: "house", path: require("@/assets/images/agent_icon/house.png") },
                { name: "land_property", path: require("@/assets/images/agent_icon/land_property.png") },
                { name: "mail_reply", path: require("@/assets/images/agent_icon/mail_reply.png") },
                { name: "search_web", path: require("@/assets/images/agent_icon/search_web.png") },
            ],

        }
    },
    created(){
    },
    methods: {
        saveIcon(icon_obj) {
            this.selectedIcon = icon_obj.name;
            this.$emit('emitSelectAgentIconDialog', icon_obj);
        }
    },
    watch: {
    }
});
</script>